import React, { useState } from "react";
import { formatDateToYMD } from "../../../../../utilities/dateUtils";
import SimpleDateField from "../../../genericComponents/simpleTextField/SimpleDateField";
import SimpleThemedButton from "../../../genericComponents/simpleTextField/SimpleThemedButton";

function UpdateNurtureDate({ handleDateUpdatePostActions }) {
  const [newDate, setNewDate] = useState(formatDateToYMD(new Date()));
  const [loading, setLoading] = useState(false);

  const processBtnClick = async (newDate) => {
    try {
      setLoading(true);
      await handleDateUpdatePostActions(newDate);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div>Campaign Start Date cannot be in the past.</div>
      <span
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "flex-start",
          gap: "1rem",
          marginBottom: "1rem",
          marginTop: "1rem",
        }}
      >
        <SimpleDateField
          disablePastDates={true}
          label="Select Revised Campaign Date"
          labelPosition="top-left"
          value={newDate}
          onChange={async (val) => {
            setNewDate(formatDateToYMD(new Date(val)));
          }}
          minDate={new Date(2020, 0, 1)}
          maxDate={new Date(2030, 11, 31)}
          disableWeekends
          customWidth="100%"
        />
        <SimpleThemedButton
          buttonText="Update"
          onBtnClick={() => processBtnClick(newDate)}
          isLoading={loading}
          loaderTxt="Updating"
        />
      </span>
    </>
  );
}

export default UpdateNurtureDate;
